module.exports = "https://www.gc-qa.gnp.com.mx/abe8eaeb637ae4b9982d6c15d6560d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle_contratante.png
// module id = 960
// module chunks = 0